module.exports = __webpack_public_path__ + "img/carousel2.a4fcb97f.png";